import { render, staticRenderFns } from "./CartaoOSFilhas.vue?vue&type=template&id=18689e52&scoped=true"
import script from "./CartaoOSFilhas.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoOSFilhas.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoOSFilhas.vue?vue&type=style&index=0&id=18689e52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18689e52",
  null
  
)

export default component.exports